import script from "./TableGraphSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./TableGraphSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./TableGraphSwitcher.vue?vue&type=style&index=0&id=0160641f&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0160641f"]])

export default __exports__